/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateOrganisationAccessModeDataAccessModeSchema = z.enum(['implicit', 'explicit'])

export type UpdateOrganisationAccessModeDataAccessModeSchema = z.infer<
	typeof updateOrganisationAccessModeDataAccessModeSchema
>
